import { AppCodeUse } from 'data/records'
import { collection, resource, findSelector } from 'data/helpers/apiv3'
import { fulfilled } from 'lib/promiseMiddlewareHelpers'
import { loadAllPages } from 'lib/loadAllPages'
import { Map, OrderedSet } from 'immutable'

const [api, actions] = resource(AppCodeUse, [
  ['list', collection.get('', ['parentType', 'parentId'])]
])
actions.loadAllAppCodeUses = (parentType, parentId, params) => (dispatch) => {
  const loadACUPage = ({ pageIndex: page, perPage }) => {
    return dispatch(actions.list({ parentType, parentId }, { page, perPage, ...params }))
  }
  const isLastPage = ({ perPage, pageIndex, pageResults }) => {
    return perPage * (pageIndex + 1) >= pageResults.value.totalCount
  }

  return loadAllPages({
    promiseProducer: loadACUPage,
    perPage: 100,
    isLastPage
  })
}

const selectors = {
  ...findSelector(AppCodeUse),
  byParent: (state, parentType, parentId) => state.apiv3.appCodeUse.getIn(['byParent', parentType, parentId], OrderedSet())
}

const initialState = {
  byParent: Map() // parentType -> parentId -> OrderedSet(AppCodeUseId)
}

const reducers = {
  [fulfilled(actions.list.type)]: (state, action) => {
    const { parent_type: parentType, parent_id: parentId } = action.payload.meta
    const prevSlice = state.getIn(['byParent', parentType, parentId], OrderedSet())
    const acuIds = OrderedSet(action.payload.results.map(r => r.id))
    return state.setIn(['byParent', parentType, parentId], prevSlice.concat(acuIds))
  }
}

export {
  api as appCodeUseApi,
  actions as appCodeUseActions,
  selectors as appCodeUseSelectors,
  reducers as appCodeUseReducers,
  initialState as appCodeUseInitialState
}
